import { j as e } from "../../../../jsx-runtime-BwWtxLpl.js";
import { useContext as v, useState as B } from "react";
import { FileUploaderContext as w } from "../file-uploader.context.js";
import z from "classnames";
import { MotifProgressBar as D } from "../../../progress-bar/progress-bar.js";
import { MotifButton as G } from "../../../button/button.js";
import "../../../dropdown-portal/dropdown-portal.js";
import { MotifIcon as l } from "../../../icon/icon.js";
import { IconContext as K } from "../../../icon/icon.context.js";
import { IconoirXmark as R, IconoirTrash as V, IconoirCheck as X, IconoirEmptyPage as Y } from "@ey-xd/motif-icon";
import { MotifIconButton as C } from "../../../button/icon-button/icon-button.js";
const o = {
  close: R,
  delete: V,
  check: X,
  file: Y
}, I = (n) => {
  if (n === 0)
    return "0 Bytes";
  const a = 1024, s = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], r = Math.floor(Math.log(n) / Math.log(a));
  return `${parseFloat((n / Math.pow(a, r)).toFixed(2))} ${s[r]}`;
}, te = ({
  customButton: n = "",
  className: a = "",
  error: s = !1,
  errorText: r = "Upload failed, please try again",
  uploaded: c = !1,
  uploadedText: N = "100% uploaded",
  disabled: p = !1,
  fileName: m = "",
  fileSize: u = 0,
  isIndeterminate: d = !1,
  onRemove: h = () => null,
  percentUploaded: f = 0,
  removable: x = !1,
  showProgress: g = !1,
  closeButtonProps: j = {},
  icons: k
}) => {
  const { fileUploaderItem: t } = v(K), { onRetry: b } = v(w), [$, E] = B(!0);
  let i;
  t ? i = {
    ...t,
    ...k,
    close: typeof t.close == "function" ? /* @__PURE__ */ e.jsx(l, { iconFunction: t.close }) : t.close,
    delete: typeof t.delete == "function" ? /* @__PURE__ */ e.jsx(l, { iconFunction: t.delete }) : t.delete,
    check: typeof t.check == "function" ? /* @__PURE__ */ e.jsx(l, { iconFunction: t.check }) : t.check,
    file: typeof t.file == "function" ? /* @__PURE__ */ e.jsx(l, { iconFunction: t.file }) : t.file
  } : i = {
    ...o,
    ...k,
    close: typeof o.close == "function" ? /* @__PURE__ */ e.jsx(l, { iconFunction: o.close }) : o.close,
    delete: typeof o.delete == "function" ? /* @__PURE__ */ e.jsx(l, { iconFunction: o.delete }) : o.delete,
    check: typeof o.check == "function" ? /* @__PURE__ */ e.jsx(l, { iconFunction: o.check }) : o.check,
    file: typeof o.file == "function" ? /* @__PURE__ */ e.jsx(l, { iconFunction: o.file }) : o.file
  };
  const [y, F] = B(!1), T = () => {
    F(!0);
  }, L = () => {
    F(!1);
  }, M = () => {
    E(!1), h && h();
  }, P = () => f < 100 && !c || s || y && f === 100 && !c ? x ? /* @__PURE__ */ e.jsx(
    C,
    {
      "aria-label": `Click to remove file - ${m}`,
      "data-testid": "close-button",
      onClick: M,
      ...j,
      children: typeof i.close == "function" ? /* @__PURE__ */ e.jsx(l, { iconFunction: i.close }) : i.close
    }
  ) : null : y && c ? x ? /* @__PURE__ */ e.jsx(
    C,
    {
      "aria-label": `Click to remove file - ${m}`,
      "data-testid": "close-button",
      onClick: M,
      ...j,
      children: typeof i.delete == "function" ? /* @__PURE__ */ e.jsx(l, { fill: "none", iconFunction: i.delete }) : i.delete
    }
  ) : null : /* @__PURE__ */ e.jsx("span", { className: "motif-file-uploader-list-item-completed", children: typeof i.check == "function" ? /* @__PURE__ */ e.jsx(l, { fill: "none", iconFunction: i.check }) : i.check }), H = z({
    "motif-file-uploader-list-item": !0,
    "motif-file-uploader-list-item-has-error": s,
    "motif-file-uploader-list-item-disabled": p,
    [a]: !0
  });
  return $ ? /* @__PURE__ */ e.jsxs("div", { onMouseEnter: T, onMouseLeave: L, className: H, role: "list", children: [
    /* @__PURE__ */ e.jsx("div", { className: "motif-file-uploader-list-item-icon", children: typeof i.file == "function" ? /* @__PURE__ */ e.jsx(l, { size: "14", fill: "none", iconFunction: i.file }) : i.file }),
    /* @__PURE__ */ e.jsxs("div", { className: "motif-file-uploader-list-item-information", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "motif-file-uploader-list-item-description", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "motif-file-uploader-list-item-data", children: [
          /* @__PURE__ */ e.jsx("span", { className: "motif-file-uploader-list-item-name", children: m }),
          !d && !s && u > 0 && /* @__PURE__ */ e.jsx("span", { className: "motif-file-uploader-list-item-size", children: `${!c && f !== 100 ? `${I(u * (f / 100))} of ` : ""}${I(u)}` }),
          c && !s && /* @__PURE__ */ e.jsx("span", { className: "motif-file-uploader-list-item-uploaded", children: N }),
          s && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("span", { className: "motif-file-uploader-list-item-error", children: r }),
            /* @__PURE__ */ e.jsx(
              G,
              {
                className: "motif-file-uploader-list-item-try-again",
                onClick: () => b,
                type: "button",
                variant: "text",
                children: "Try again"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "motif-file-uploader-list-item-button", children: [
          n && n,
          P()
        ] })
      ] }),
      g && !c && !p && !s && /* @__PURE__ */ e.jsx(
        D,
        {
          labelPosition: d ? "top" : "right",
          resultStateLabel: "",
          isIndeterminate: d,
          value: Math.trunc(f)
        }
      )
    ] })
  ] }) : null;
};
export {
  te as MotifFileUploaderItem
};
